import { render, staticRenderFns } from "./RejectFirm.vue?vue&type=template&id=562d7108&"
import script from "./RejectFirm.vue?vue&type=script&lang=ts&"
export * from "./RejectFirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports